import { PatchLegPayload, batchLegRequest } from '@api/Trinium/Endpoints/Leg';
import { gridRowSelectionIdsSelector, useGridApiContext, useGridSelector } from '@mui/x-data-grid-pro';

import styles from '../../RenderCell.module.css';

/**
 * Row Action item that allows user to set the priority color of the row
 */
export default function PriorityAction() {
	const gridApiRef = useGridApiContext();
	const selectedRowIds = useGridSelector(gridApiRef, gridRowSelectionIdsSelector);

	const priorityClick = (priority: number) => {
		const requests: PatchLegPayload[] = [];

		for (const [legId] of selectedRowIds.entries()) {
			requests.push({
				id: Number(legId),
				priority: priority
			});
		}
		void batchLegRequest(requests);
	};

	return (
		<div className={styles.priorities}>
			<div
				className={`${styles.priority} ${styles['priority-2']}`}
				onClick={() => {
					priorityClick(2);
				}}
			></div>
			<div
				className={`${styles.priority} ${styles['priority-1']}`}
				onClick={() => {
					priorityClick(1);
				}}
			></div>
			<div
				className={`${styles.priority} ${styles['priority-0']}`}
				onClick={() => {
					priorityClick(0);
				}}
			></div>
			<div
				className={`${styles.priority} ${styles['priority--1']}`}
				onClick={() => {
					priorityClick(-1);
				}}
			></div>
			<div
				className={`${styles.priority} ${styles['priority--2']}`}
				onClick={() => {
					priorityClick(-2);
				}}
			></div>
		</div>
	);
}
